import React from 'react';
import { Link } from 'react-router-dom';
import "./works.css";

import SnapEats from "./img/snapeats.jpg";
import Tatoo from "./img/tatoo.jpg";
import Stackoverflow from "./img/stackoverflow.jpg";
import Chatt from "./img/chatt.jpg";
import Simplyhome from "./img/simplyhome.jpg";
import Sweethome from "./img/sweethome.jpg";

export default function Works() {

  const projects = [
    { id: 'one', title: 'snapeats', image: SnapEats },
    { id: 'two', title: 'sweethome', image: Sweethome },
    { id: 'three', title: 'snappychat', image: Chatt },
    { id: 'four', title: 'stackoverflow', image: Stackoverflow },
    { id: 'five', title: 'simplyhome', image: Simplyhome },
    { id: 'six', title: 'tatoo', image: Tatoo }
  ];

  return (
    <main id="main">
      <div className="site-section pb-0 site-portfolio" id='Work'>
        <div className="work-container">
          <div className="row mb-lg-5 align-items-end">
            <div className="col-md-12 col-lg-6 mb-4 mb-lg-0" data-aos="fade-up">
              <h1 className='home-title'><strong>Works</strong></h1>
              <p className="mb-0" style={{ color: "#063dcc" }}>
                Unyielding passion fuels my projects, weaving innovation into every line of code and design, consistently creating excellence
              </p>
            </div>
          </div>
          <div id="portfolio-grid" className="row no-gutter" data-aos="fade-up" data-aos-delay="200">
            {projects.map((project) => (
              <div key={project.id} className="item col-sm-6 col-md-4 col-lg-4 mb-4 pro-cards">
                <Link to={`/project/${project.title}`} className="item-wrap fancybox">
                  <div className="work-info">
                    <h3><i style={{color:'#063dcc'}} className="fa-regular fa-eye"></i></h3>
                    <span></span>
                  </div>
                  <img className="img-fluid" src={project.image} alt={project.title} />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
}
